


























import { Component, Vue } from "vue-property-decorator";
import AnimatedName from "@/components/animated-name/AnimatedName.vue";
import GitHubIcon from "@/assets/images/github.svg?inline";
import InstragramIcon from "@/assets/images/instagram.svg?inline";
import EmailIcon from "@/assets/images/paper-plane.svg?inline";
import SpotifyIcon from "@/assets/images/spotify.svg?inline";

@Component({
  components: {
    AnimatedName,
    GitHubIcon,
    EmailIcon,
    SpotifyIcon,
    InstragramIcon,
  },
})
export default class Home extends Vue {
  // May as well protect my email from any simple scraper
  private openMail(): void {
    window.open(
      `mailto:${atob("Ym9ta2FtcGdAZ21haWwuY29t")}`,
      "_blank"
    );
  }
}
